import { OnboardingFlowType } from '__generated__/api-types-and-hooks'

export const ChatBotFlowUrl = {
  [OnboardingFlowType.GetToKnowYou]: 'get-to-know-you',
  [OnboardingFlowType.GoalSetting]: 'goal-setting',
  [OnboardingFlowType.AddGoal]: 'add-goal',
  [OnboardingFlowType.AdvisorGetToKnowYou]: 'advisor-get-to-know-you',
  [OnboardingFlowType.EdoTeamMemberGetToKnowYou]: 'edo-team-member-get-to-know-you',
  [OnboardingFlowType.AdminEdoGetToKnowYou]: 'admin-edo-get-to-know-you',
  [OnboardingFlowType.SuggestGoal]: 'suggest-goal',
}

export const ChatBotFlowData = {
  'get-to-know-you': OnboardingFlowType.GetToKnowYou,
  'goal-setting': OnboardingFlowType.GoalSetting,
  'add-goal': OnboardingFlowType.AddGoal,
  'advisor-get-to-know-you': OnboardingFlowType.AdvisorGetToKnowYou,
  'edo-team-member-get-to-know-you': OnboardingFlowType.EdoTeamMemberGetToKnowYou,
  'admin-edo-get-to-know-you': OnboardingFlowType.AdminEdoGetToKnowYou,
  'suggest-goal': OnboardingFlowType.SuggestGoal,
}

export const audioMaxDuration = 120
